import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import Downloadicon from '../../../../../../media/billing/ic-download.svg'
import AddConvertibleClassModal from './add-convertible-class-modal'
import {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {useAuth} from '../../../../auth'
import {downloadDocument} from '../../../founders-and-promoters/core/_requests'
import {toast} from 'react-toastify'
import {getConvertibleSecurityClassById} from '../../core/_requests'
import Skeleton from 'react-loading-skeleton'
import {
  formatNumber,
  getCurrencySymbol,
  getFileType,
  parseCurrency,
  toTitleCase,
} from '../../../../../core/_util'
import {useDateFormat} from '../../../../../hooks/useDateFormat'
import {useCurrency} from '../../../../../hooks/useCurrency'
import {participatingOptions, seniorityOptions} from '../../core/_constants'
import {TransactionModalType} from '../../core/_models'
import {NoDataPage} from '../../../../resources/components/NoDataPage'

export default function ConvertibleClassDetailsModal({
  isActive,
  setIsActive,
  convertibleClassId,
  setIsConvertibleCreateOrUpdate,
  isConvertibleCreateOrUpdate,
  setSidebar,
  setIsShareClassDropdown,
  setModalType,
  setIsCreate,
  setConvertibleClassId,
}: {
  isActive: boolean
  setIsActive: () => void
  convertibleClassId: string | null
  setIsConvertibleCreateOrUpdate: Dispatch<SetStateAction<boolean>>
  isConvertibleCreateOrUpdate: boolean
  setSidebar: Dispatch<SetStateAction<number>>
  setIsShareClassDropdown: Dispatch<SetStateAction<boolean>>
  setConvertibleClassId: Dispatch<SetStateAction<string | null>>
  setModalType: Dispatch<SetStateAction<TransactionModalType>>
  setIsCreate: Dispatch<SetStateAction<boolean>>
}) {
  const {companyId, companyCurrency} = useAuth()
  const [convertibleClassDetailsLoading, setConvertibleClassDetailsLoading] =
    useState<boolean>(false)
  const [convertibleSecurityClassDetails, setConversibleSecurityClassDetails] = useState<any>(null)
  const {formatMessage} = useIntl()
  const {getDateValue} = useDateFormat()
  const {currencyOptions} = useCurrency()
  const [activeModal, setActiveModal] = useState<TransactionModalType>('none')

  const openModal = (modalType: TransactionModalType) => {
    setActiveModal(modalType)
  }
  const closeModal = () => {
    setActiveModal('none')
  }

  const downloadFile = async (name: string) => {
    try {
      const {
        data: {success, data, errors},
      } = await downloadDocument(name, companyId!)
      if (success) {
        const link = document.createElement('a')
        link.href = data
        link.setAttribute('download', name)
        document.body.appendChild(link)
        toast.success('Document downloaded successfully')
        link.click()
        link.remove()
      } else {
        toast.error(errors[0])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchConvertibleSecurityClassDetails = async () => {
    if (!convertibleClassId) return
    setConvertibleClassDetailsLoading(true)
    try {
      const {
        data: {success, data},
      } = await getConvertibleSecurityClassById(companyId!, convertibleClassId)
      if (success && data) {
        setConversibleSecurityClassDetails(data)
        setIsConvertibleCreateOrUpdate(false)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setConvertibleClassDetailsLoading(false)
    }
  }

  useEffect(() => {
    fetchConvertibleSecurityClassDetails()
  }, [convertibleClassId, isConvertibleCreateOrUpdate]) // eslint-disable-line react-hooks/exhaustive-deps

  console.log(convertibleSecurityClassDetails, 'convertibleSecurityClassDetails')

  return (
    <>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive()
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <h2>{formatMessage({id: 'Convertible Class View'})}</h2>
        </Modal.Header>
        <Modal.Body className='container'>
          <div className='d-md-flex justify-content-between w-100 align-items-center mb-6'>
            <h1 className='fs-4'>{formatMessage({id: 'Basic Details'})}</h1>
            <div className='h-100 border bg-white d-flex align-items-center rounded'>
              <button
                className='btn btn-primary font-size-12 px-4 py-2 w-100 w-md-auto'
                title='edit transaction'
                onClick={() => openModal('AddConvertibleClassModal')}
              >
                {formatMessage({id: 'Edit Convertible Notes'})}
              </button>
            </div>
          </div>

          <div className='row gx-6 justify-content-start mb-4'>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Convertible Type'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails
                    ? convertibleSecurityClassDetails?.convertibleType.toUpperCase()
                    : '-'}
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Convertible Class'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <div
                  style={{
                    backgroundColor: `rgba(${parseInt(
                      convertibleSecurityClassDetails?.tagColor.slice(1, 3),
                      16
                    )}, 
            ${parseInt(convertibleSecurityClassDetails?.tagColor.slice(3, 5), 16)}, 
            ${parseInt(convertibleSecurityClassDetails?.tagColor.slice(5, 7), 16)}, 
            0.4)`,
                    opacity: '0.8',
                    padding: '5px',
                    width: '70%',
                    borderRadius: '5px',
                  }}
                >
                  <p className='font-size-14 m-0 font-weight-normal'>
                    {convertibleSecurityClassDetails?.className}
                  </p>
                </div>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Convertible Class Prefix'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails?.classCode ?? '-'}
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>{formatMessage({id: 'Share Class'})}</p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <div
                  style={{
                    backgroundColor: `rgba(${parseInt(
                      convertibleSecurityClassDetails?.shareClass?.tagColor.slice(1, 3),
                      16
                    )}, 
            ${parseInt(convertibleSecurityClassDetails?.shareClass?.tagColor.slice(3, 5), 16)}, 
            ${parseInt(convertibleSecurityClassDetails?.shareClass?.tagColor.slice(5, 7), 16)}, 
            0.4)`,
                    opacity: '0.8',
                    padding: '5px',
                    width: '70%',
                    borderRadius: '5px',
                  }}
                >
                  <p className='font-size-14 m-0 font-weight-normal'>
                    {convertibleSecurityClassDetails?.shareClass?.className}
                  </p>
                </div>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>{formatMessage({id: 'Currency'})}</p>
              <p className='font-size-14 mb-0'>{companyCurrency}</p>
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>{formatMessage({id: 'Issue Date'})}</p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails?.issueDate
                    ? getDateValue(convertibleSecurityClassDetails?.issueDate)
                    : '-'}
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Maturity Period'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails?.maturity
                    ? `${convertibleSecurityClassDetails?.maturity} months`
                    : '-'}
                </p>
              )}
            </div>
          </div>

          <div className='seperator bg-dark border mb-6'></div>

          <div className='d-md-flex justify-content-between w-100 align-items-center mb-6'>
            <h1 className='fs-4'>{formatMessage({id: 'Conversion Parameters'})}</h1>
          </div>
          <div className='row gx-6 justify-content-start mb-4'>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>{formatMessage({id: 'Valuation Cap'})}</p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails?.valuationCap
                    ? `${companyCurrency} ${getCurrencySymbol(
                        companyCurrency,
                        currencyOptions
                      )} ${parseCurrency(convertibleSecurityClassDetails?.valuationCap)}`
                    : '-'}
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Valuation Floor'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails?.valuationFloor
                    ? `${companyCurrency} ${getCurrencySymbol(
                        companyCurrency,
                        currencyOptions
                      )} ${parseCurrency(convertibleSecurityClassDetails?.valuationFloor)}`
                    : '-'}
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Convertible Discount (%)'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails?.conversionDiscount
                    ? formatNumber(parseInt(convertibleSecurityClassDetails?.conversionDiscount))
                    : '-'}
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Conversion Trigger'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 m-0 font-weight-normal'>
                  {convertibleSecurityClassDetails?.conversionTrigger
                    ? `${companyCurrency} ${getCurrencySymbol(
                        companyCurrency,
                        currencyOptions
                      )} ${parseCurrency(convertibleSecurityClassDetails?.conversionTrigger)}`
                    : '-'}
                </p>
              )}
            </div>
          </div>

          {convertibleSecurityClassDetails?.convertibleInterestRate === 'yes' && (
            <>
              <div className='seperator bg-dark border mb-6'></div>

              <div className='d-md-flex justify-content-between w-100 align-items-center mb-6'>
                <h1 className='fs-4'>{formatMessage({id: 'Conversion Interest Rate'})}</h1>
              </div>
              <div className='row gx-6 justify-content-start mb-4'>
                <div className='col-lg-3 col-md-4 col-6 mb-8'>
                  <p className='text muted font-size-12 mb-0'>
                    {formatMessage({id: 'Rate (Annual) (%)'})}
                  </p>
                  {convertibleClassDetailsLoading ? (
                    <Skeleton
                      height={30}
                      width={120}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <p className='font-size-14 m-0 font-weight-normal'>
                      {convertibleSecurityClassDetails?.rate
                        ? formatNumber(convertibleSecurityClassDetails?.rate)
                        : '-'}
                    </p>
                  )}
                </div>
                <div className='col-lg-3 col-md-4 col-6 mb-8'>
                  <p className='text muted font-size-12 mb-0'>
                    {formatMessage({id: 'Accrual Period'})}
                  </p>
                  {convertibleClassDetailsLoading ? (
                    <Skeleton
                      height={30}
                      width={120}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <p className='font-size-14 m-0 font-weight-normal'>
                      {convertibleSecurityClassDetails?.accrualPeriod
                        ? toTitleCase(convertibleSecurityClassDetails?.accrualPeriod)
                        : '-'}
                    </p>
                  )}
                </div>
                <div className='col-lg-3 col-md-4 col-6 mb-8'>
                  <p className='text muted font-size-12 mb-0'>
                    {formatMessage({id: 'Compounding Method'})}
                  </p>
                  {convertibleClassDetailsLoading ? (
                    <Skeleton
                      height={30}
                      width={120}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <p className='font-size-14 m-0 font-weight-normal'>
                      {convertibleSecurityClassDetails?.compoundingMethod
                        ? toTitleCase(convertibleSecurityClassDetails?.compoundingMethod)
                        : '-'}
                    </p>
                  )}
                </div>
              </div>
            </>
          )}

          <div className='seperator bg-dark border mb-6'></div>

          <div className='d-md-flex justify-content-between w-100 align-items-center mb-6'>
            <h1 className='fs-4'>{formatMessage({id: 'Redemption Parameters'})}</h1>
          </div>
          <div className='row gx-6 justify-content-start mb-4'>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Seniority Level'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 mb-0'>
                  {
                    seniorityOptions.find(
                      (seniority) =>
                        seniority.value === convertibleSecurityClassDetails?.seniorityLevel
                    )?.label
                  }
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>{formatMessage({id: 'Multiplier'})}</p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 mb-0'>
                  {convertibleSecurityClassDetails?.multiplier
                    ? formatNumber(convertibleSecurityClassDetails?.multiplier)
                    : '-'}
                  x
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>
                {formatMessage({id: 'Participation Cap'})}
              </p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 mb-0'>
                  {convertibleSecurityClassDetails?.participatingCap
                    ? `${formatNumber(convertibleSecurityClassDetails?.participatingCap)}x`
                    : '-'}
                </p>
              )}
            </div>
            <div className='col-lg-3 col-md-4 col-6 mb-8'>
              <p className='text muted font-size-12 mb-0'>{formatMessage({id: 'Convertible'})}</p>
              {convertibleClassDetailsLoading ? (
                <Skeleton
                  height={30}
                  width={120}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 mb-0'>
                  {
                    participatingOptions.find(
                      (participate) =>
                        participate.value === convertibleSecurityClassDetails?.convertible
                    )?.label
                  }
                </p>
              )}
            </div>
          </div>

          {convertibleSecurityClassDetails?.redemptionInterestRate === 'yes' && (
            <>
              <div className='seperator bg-dark border mb-6'></div>

              <div className='d-md-flex justify-content-between w-100 align-items-center mb-6'>
                <h1 className='fs-4'>{formatMessage({id: 'Redemption Interest Rate'})}</h1>
              </div>
              <div className='row gx-6 justify-content-start mb-4'>
                <div className='col-lg-3 col-md-4 col-6 mb-8'>
                  <p className='text muted font-size-12 mb-0'>
                    {formatMessage({id: 'Rate (Annual) (%)'})}
                  </p>
                  {convertibleClassDetailsLoading ? (
                    <Skeleton
                      height={30}
                      width={120}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <p className='font-size-14 m-0 font-weight-normal'>
                      {convertibleSecurityClassDetails?.redemptionRate
                        ? formatNumber(convertibleSecurityClassDetails?.redemptionRate)
                        : '-'}
                    </p>
                  )}
                </div>
                <div className='col-lg-3 col-md-4 col-6 mb-8'>
                  <p className='text muted font-size-12 mb-0'>
                    {formatMessage({id: 'Accrual Period'})}
                  </p>
                  {convertibleClassDetailsLoading ? (
                    <Skeleton
                      height={30}
                      width={120}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <p className='font-size-14 m-0 font-weight-normal'>
                      {convertibleSecurityClassDetails?.redemptionAccrualPeriod
                        ? toTitleCase(convertibleSecurityClassDetails?.redemptionAccrualPeriod)
                        : '-'}
                    </p>
                  )}
                </div>
                <div className='col-lg-3 col-md-4 col-6 mb-8'>
                  <p className='text muted font-size-12 mb-0'>
                    {formatMessage({id: 'Compounding Method'})}
                  </p>
                  {convertibleClassDetailsLoading ? (
                    <Skeleton
                      height={30}
                      width={120}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <p className='font-size-14 m-0 font-weight-normal'>
                      {convertibleSecurityClassDetails?.redemptionCompoundingMethod
                        ? toTitleCase(convertibleSecurityClassDetails?.redemptionCompoundingMethod)
                        : '-'}
                    </p>
                  )}
                </div>
              </div>
            </>
          )}

          <div className='seperator bg-dark border mb-6'></div>

          <div className='d-md-flex justify-content-between w-100 align-items-center mb-6'>
            <h1 className='fs-4'>{formatMessage({id: 'Documents'})}</h1>
          </div>

          {convertibleClassDetailsLoading ? (
            <div className='d-flex gap-3'>
              <div className='card p-3 border border-muted'>
                <Skeleton
                  height={30}
                  width={200}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />

                <Skeleton
                  height={60}
                  width={200}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
              <div className='card p-3 border border-muted'>
                <Skeleton
                  height={30}
                  width={200}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                <Skeleton
                  height={60}
                  width={200}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            </div>
          ) : (
            <div className='row'>
              {convertibleSecurityClassDetails?.documents.length === 0 ? (
                <NoDataPage />
              ) : (
                convertibleSecurityClassDetails?.documents.map((file: any) => (
                  <div className='col-12 col-md-6 col-lg-4 mb-4' key={file.documentId}>
                    <div className='card p-3 border border-muted'>
                      <img
                        src={getFileType(file.name)}
                        alt={file.name}
                        style={{height: '35px', width: '35px'}}
                      />
                      <div className='d-flex justify-content-between align-items-center'>
                        <p className='p-0 m-0 w-75'>{file?.name?.split('/').pop()}</p>
                        <img
                          className='cursor-pointer'
                          src={Downloadicon}
                          alt='download'
                          onClick={() => downloadFile(file.name)}
                        />
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
      {activeModal === 'AddConvertibleClassModal' && convertibleClassId && (
        <AddConvertibleClassModal
          isActive={true}
          setIsActive={closeModal}
          convertibleClassId={convertibleClassId}
          setIsConvertibleCreateOrUpdate={setIsConvertibleCreateOrUpdate}
          setSidebar={setSidebar}
          openModal={openModal}
          setIsShareClassDropdown={setIsShareClassDropdown}
          setModalType={setModalType}
          setIsCreate={setIsCreate}
        />
      )}
    </>
  )
}
